import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import stl from "../../../../SearchComponent.module.css";
import AsideTags from "../AsideTags/AsideTags";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import SearchHeader from "@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/MobileFilters/SearchHeader/SearchHeader";
import SelectedTags from "../../../SelectedTags/SelectedTags";
import MakeModelYearTags from "../../../MakeModelYearTags/MakeModelYearTags";
import YearsSelectedTags from "../../../Years/YearsSelectedTags/YearsSelectedTags";
import YearsTags from "../../../Years/YearsTags/YearsTags";
import CarCountriesTags from "../../../CarCountriesTags/CarCountriesTags";
import { useTranslation } from "@i18n";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { CDN_LINK } from "@globalConfig";
import useMoveDomElementWhenScrolling from "@hooks/useMoveDomElementWhenScrolling";
import ToggleCarCompare from "@/_MiniApps/CarCompare/Components/ToggleCarCompare";
import useFilterPage from "@/pages/search/searchHooks/useSearchAndFilters";
var fallback = {
  fallback: null
};
var UnbxdSort = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "UnbxdSort-UnbxdSort";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "UnbxdSort-UnbxdSort" */"../../../UnbxdSort/UnbxdSort");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../../../UnbxdSort/UnbxdSort");
    }
    return eval('require.resolve')("../../../UnbxdSort/UnbxdSort");
  }
}, fallback);
var computeTopPosition = function computeTopPosition() {
  if (__IS_SSR__) return 0;
  if (window.headerTopPosition) {
    return window.headerTopPosition;
  }
  var isHeaderSearchExists = getComputedStyle(document.querySelector(".abSearchTextClass")).display === "none";
  /* Offset that slides the sticky block up far enough to hide the search row
     but keep the filters row visible. SearchHeader is a single 68px row
     (15px padding + 38px content + 15px padding); the content grew from 37px
     when the logo went to 83x38. It used to be a 124px two-row stack, which is
     where -116 came from. */
  window.headerTopPosition = isHeaderSearchExists ? -61 : -68;
  return window.headerTopPosition;
};
var MobileFilters = function MobileFilters(_ref) {
  var _filters$find;
  var className = _ref.className,
    loading = _ref.loading,
    setFilterOnMobile = _ref.setFilterOnMobile,
    handleDeleteFilters = _ref.handleDeleteFilters,
    isSideMenuOpened = _ref.isSideMenuOpened,
    selectedOptions = _ref.selectedOptions,
    sort = _ref.sort,
    sortOptions = _ref.sortOptions,
    location = _ref.location,
    setTempSelectedOptions = _ref.setTempSelectedOptions,
    filters = _ref.filters,
    metaData = _ref.metaData;
  var _useFilterPage = useFilterPage(),
    isLoading = _useFilterPage.isLoading;
  var isYearsPage = location.pathname.includes("/years");
  var _useMoveDomElementWhe = useMoveDomElementWhenScrolling(isLoading, computeTopPosition),
    movableHeader = _useMoveDomElementWhe.movableHeader;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isAuto = location.pathname.includes("/autos");
  var isCarCountriesPage = location.pathname.includes("/car-countries/");
  var showYearsTags = isYearsPage && !loading && filters.length > 4 || isAuto && !loading && filters.length > 4 && !selectedOptions.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "div_searchHeader",
    ref: movableHeader,
    className: [stl.searchHeader, className ? className : undefined].join(" ")
  }, /*#__PURE__*/React.createElement(SearchHeader, null), /*#__PURE__*/React.createElement("div", {
    className: ["fixedFilltersContainer m-show showSpF", stl.rvmpBotfx].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, !loading ? /*#__PURE__*/React.createElement("button", {
    id: "openFilter_1",
    onClick: function onClick() {
      setFilterOnMobile(true);
      document.body.style.overflow = "hidden";
    },
    className: [stl.filterBtnSP, "showFltr", stl.rvmpmobAsideBtn, "w-[calc(100%/3)]"].join(" ")
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    loading: "eager",
    src: CDN_LINK + "/assets/images/filters-icon-mobile.svg",
    width: 24,
    height: 24,
    alt: "filters",
    "aria-label": "filters"
  }), t("filter", {
    ns: "web_search"
  }), selectedOptions.length !== 0 && /*#__PURE__*/React.createElement("div", {
    id: "filter-mobile-count-badge",
    className: stl.count
  }, /*#__PURE__*/React.createElement("span", null, selectedOptions.length))) : /*#__PURE__*/React.createElement("div", {
    className: "mobileDummyLoader"
  }, /*#__PURE__*/React.createElement(BoxLoading, null), /*#__PURE__*/React.createElement(BoxLoading, null)), !loading && /*#__PURE__*/React.createElement("div", {
    id: "filter-mobile-sort-wrapper",
    className: "w-[calc(100%/3)]"
  }, /*#__PURE__*/React.createElement(UnbxdSort, {
    sort: sort,
    selectedOptions: selectedOptions,
    sortOptions: sortOptions,
    filters: filters
  })), !loading && /*#__PURE__*/React.createElement("div", {
    id: "filter-mobile-compare-wrapper",
    className: "border-solid flex justify-center items-center w-[calc(100%/3)] border-r border-[#e1e8f2]"
  }, /*#__PURE__*/React.createElement(ToggleCarCompare, null)))), location.pathname.includes("/filters") && /*#__PURE__*/React.createElement(AsideTags, {
    id: "AsideHeight3",
    className: "m-show",
    selectedOptions: selectedOptions,
    handleDeleteFilters: handleDeleteFilters,
    isSideMenuOpened: isSideMenuOpened,
    setTempSelectedOptions: setTempSelectedOptions
  }), isAuto && !loading && selectedOptions.length && filters.length > 4 ? /*#__PURE__*/React.createElement(SelectedTags, {
    className: "m-show",
    tags: selectedOptions
  }) : null, isAuto && !loading && filters.length > 4 && /*#__PURE__*/React.createElement(MakeModelYearTags, {
    className: "".concat(showYearsTags ? stl.noBorder : "", " m-show"),
    selectedOptions: selectedOptions,
    filters: filters,
    loading: loading,
    metaData: metaData,
    showYearsTags: showYearsTags
  }), isCarCountriesPage && !loading && /*#__PURE__*/React.createElement(MakeModelYearTags, {
    className: "".concat(showYearsTags ? stl.noBorder : "", " m-show"),
    selectedOptions: [],
    filters: filters,
    metaData: {
      seoData: {
        makes: ((_filters$find = filters.find(function (f) {
          return (f === null || f === void 0 ? void 0 : f.filterField) === "make_id";
        })) === null || _filters$find === void 0 ? void 0 : _filters$find.values) || []
      }
    },
    baseUrl: "/autos"
  }), isYearsPage && !loading && selectedOptions.length && filters.length > 4 ? /*#__PURE__*/React.createElement(YearsSelectedTags, {
    className: "m-show",
    tags: selectedOptions
  }) : null, showYearsTags && /*#__PURE__*/React.createElement(YearsTags, {
    className: "m-show",
    selectedOptions: selectedOptions,
    filters: filters,
    loading: loading,
    metaData: metaData
  }), showYearsTags && /*#__PURE__*/React.createElement(CarCountriesTags, {
    className: "m-show",
    filters: filters
  })));
};
export default MobileFilters;